import { Record } from "./.fable/fable-library.3.1.16/Types.js";
import { tuple_type, int32_type, record_type, class_type, float64_type, string_type } from "./.fable/fable-library.3.1.16/Reflection.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "./.fable/Thoth.Json.6.0.0/Decode.fs.js";
import { equals, compareArrays, uncurry } from "./.fable/fable-library.3.1.16/Util.js";
import { printf, toConsole } from "./.fable/fable-library.3.1.16/String.js";
import { map as map_1, ofArray, empty, cons, append, singleton, concat } from "./.fable/fable-library.3.1.16/List.js";
import { ControlChangeEvent, Message, LoadingState } from "./Model.js";
import { add as add_1, map, empty as empty_1, change as change_1, fold } from "./.fable/fable-library.3.1.16/Map.js";
import { add, singleton as singleton_1, fold as fold_1 } from "./.fable/fable-library.3.1.16/Set.js";
import { getFloatValue } from "./Mod.js";
import { Cmd_ofSub } from "./.fable/Fable.Elmish.3.1.0/cmd.fs.js";

export class ModPlacement extends Record {
    constructor(label, controls) {
        super();
        this.label = label;
        this.controls = controls;
    }
}

export function ModPlacement$reflection() {
    return record_type("Patchy.Client.Storage.ModPlacement", [], ModPlacement, () => [["label", string_type], ["controls", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, float64_type])]]);
}

export class Patch extends Record {
    constructor(cables, mods) {
        super();
        this.cables = cables;
        this.mods = mods;
    }
}

export function Patch$reflection() {
    return record_type("Patchy.Client.Storage.Patch", [], Patch, () => [["cables", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [tuple_type(tuple_type(int32_type, int32_type), int32_type), class_type("Microsoft.FSharp.Collections.FSharpSet`1", [tuple_type(tuple_type(int32_type, int32_type), int32_type)])])], ["mods", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [tuple_type(int32_type, int32_type), ModPlacement$reflection()])]]);
}

const storageKey = "patchy";

export function fetch$() {
    let matchValue;
    const json = localStorage.getItem(storageKey);
    matchValue = fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(Patch$reflection(), void 0, void 0)), json);
    if (matchValue.tag === 1) {
        toConsole(printf("deserialization error: %A"))(matchValue.fields[0]);
        return void 0;
    }
    else {
        return matchValue.fields[0];
    }
}

export function save(patch) {
    toConsole(printf("save"));
    localStorage.setItem(storageKey, JSON.stringify(patch));
}

export function toMsg(_arg1) {
    return concat([singleton(new Message(20, new LoadingState(1))), fold((all, position, _arg2) => append(cons(new Message(2, position, _arg2.label), fold((all_1, name, value) => cons(new Message(14, new ControlChangeEvent(position, name, value)), all_1), empty(), _arg2.controls)), all), empty(), _arg1.mods), singleton(new Message(20, new LoadingState(0))), fold((all_2, src, set$) => fold_1((all_3, dest) => append(all_3, ofArray([new Message(3, src), new Message(4, dest)])), all_2, set$), empty(), _arg1.cables)]);
}

export function toPatch(_arg1) {
    return new Patch(fold((all_1, _arg6, _arg5) => {
        const dest = _arg5.dest;
        return change_1(_arg5.src, (arg) => {
            let _arg7;
            return _arg7 = arg, (_arg7 == null) ? singleton_1(dest, {
                Compare: (x, y) => compareArrays(x, y),
            }) : add(dest, _arg7);
        }, all_1);
    }, empty_1(), _arg1.cables), map((_arg3, _arg2) => (new ModPlacement(_arg2.def.name, fold_1((all, _arg4) => {
        const label = _arg4.label;
        return add_1(label, getFloatValue(label, _arg2.state), all);
    }, empty_1(), _arg2.def.controls))), _arg1.mods));
}

export function saveCmd(model) {
    return Cmd_ofSub((dispatch) => {
        if (equals(model.loading, new LoadingState(2))) {
            save(toPatch(model));
            dispatch(new Message(19));
        }
    });
}

export const loadCmd = Cmd_ofSub((dispatch) => {
    const matchValue_1 = fetch$();
    if (matchValue_1 == null) {
    }
    else {
        void Promise.all(map_1((message) => (new Promise(((onSuccess, _arg1) => {
            void setTimeout(() => {
                dispatch(message);
                onSuccess();
            }, 0);
        }))), toMsg(matchValue_1))).then((_arg2) => {
            dispatch(new Message(20, new LoadingState(2)));
        });
    }
});

